import React, { ReactElement, useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import AppLoader from "../../components/apploader/AppLoader";
import InitSharedRepo from "../../../../shared";
import { downloadForm } from '../../../../shared/src/services/surgeryForms'
import { useDispatch, useSelector } from "react-redux";
import { _snackbarAcknowledgement } from "../../../../shared/src/store/actions/AuthActions";

const PatientFormDownloadError = (): ReactElement => {
    const { t } = useTranslation();
    const error = useSelector((state: any) => state.auth)
    return (
        <div className="flex-centering">
            <h4>{error.errorReason ?? t('PATIENT_FORMS.DOWNLOAD_ERROR')}</h4>
        </div>
    );
};

const DownloadPatientForm = (): ReactElement => {
    const location = useLocation(); // For query parameters
    const searchParams = new URLSearchParams(location.search);
    const { code } = useParams<{ code: string }>();
    const token: string = searchParams.get("token") ?? ""
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isErrorLoading, setIsErrorLoading] = useState<boolean>(false);
    const { t } = useTranslation();
    const dispatch = useDispatch()

    function downloadBase64FromBuffer(buffer: Buffer, filename: string, mime_type: string) {
        // Convert the buffer to a base64 string
        const base64String = bufferToBase64(buffer);

        // Create a data URI with the base64 string (e.g., for PNG)
        const dataURI = `data:${mime_type};base64,${base64String}`;

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = dataURI;
        link.download = filename;

        // Trigger the download
        link.click();
    }

    // Helper function to convert a buffer to base64 string
    function bufferToBase64(buffer: Iterable<number>) {
        const uint8Array = new Uint8Array(buffer);
        let binary = '';
        uint8Array.forEach((byte) => {
            binary += String.fromCharCode(byte);
        });
        return btoa(binary); // Convert binary to base64
    }

    const downloadFormData = async () => {
        try {
            setIsLoading(true)
            const response = await downloadForm(code)
            const { file_data, name, extension, mime_type } = response.data.data
            downloadBase64FromBuffer(file_data.data, `${name}.${extension}`, mime_type)
        }
        catch (error) {
            setIsErrorLoading(true)
            const err = error as any;
            if (err) {
                if (err.response && err.response.status === 400) {
                    dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, 'error'))
                } else {
                    dispatch(_snackbarAcknowledgement(true, err.message, 'error'))
                }
            }
        }
        finally {
            setIsLoading(false)
            // setIsErrorLoading(false)
        }
    }

    useEffect(() => {
        InitSharedRepo.initAfterAuth(token)
        downloadFormData();
    }, [code, token])

    if (isLoading) {
        return <AppLoader />
    }

    return isErrorLoading ? (<PatientFormDownloadError />) : (
        <div className="flex-centering">
            <h4>{t('PATIENT_FORMS.DOWNLOAD_SUCCESS')}</h4>
        </div>
    )
}

export default DownloadPatientForm